unit UFakModel;

interface

uses
  Js;

type
  TFakModel = class
  private
    FBezeichnung: string;
    FId: Integer;
    FNr: string;
    FAbrechnung: Boolean;
    procedure SetBezeichnung(const Value: string);
    procedure SetId(const Value: Integer);
    procedure SetNr(const Value: string);
    procedure SetAbrechnung(const Value: Boolean);
  public
    constructor Create; overload;
    constructor Create(json: string); overload;
    function ToJson: string;
    function ToString: string; override;
    function ToStringV1: string;
    procedure ClearValues;
    procedure SetValues(json: string); overload;
    procedure SetValues(obj: TJsObject); overload;
    property Id: Integer read FId write SetId;
    property Nr: string read FNr write SetNr;
    property Bezeichnung: string read FBezeichnung write SetBezeichnung;
    property Abrechnung: Boolean read FAbrechnung write SetAbrechnung;
  end;

implementation

uses
  System.SysUtils, WebLib.json, UEssentialHelper;

{ TFakModel }

procedure TFakModel.ClearValues;
begin
  Self.Id := 0;
  Self.Nr := '';
  Self.Bezeichnung := '';
  Self.Abrechnung := false;
end;

constructor TFakModel.Create;
begin
  Self.ClearValues;
end;

constructor TFakModel.Create(json: string);
begin
  Self.SetValues(json);
end;

procedure TFakModel.SetAbrechnung(const Value: Boolean);
begin
  FAbrechnung := Value;
end;

procedure TFakModel.SetBezeichnung(const Value: string);
begin
  FBezeichnung := Value;
end;

procedure TFakModel.SetId(const Value: Integer);
begin
  FId := Value;
end;

procedure TFakModel.SetNr(const Value: string);
begin
  FNr := Value;
end;

procedure TFakModel.SetValues(obj: TJsObject);
begin
  Self.ClearValues;
  if obj['Id'] <> nil then
    Self.Id := StrToInt(string(obj['Id']));
  if obj['Nr'] <> nil then
    Self.Nr := string(obj['Nr']);
  if obj['Bezeichnung'] <> nil then
    Self.Bezeichnung := string(obj['Bezeichnung']);
  if obj['Abrechnung'] <> nil then
    Self.Abrechnung := StrToBoolean(string(obj['Abrechnung']));
end;

function TFakModel.ToJson: string;
var
  obj: TJsonObject;
begin
  obj := TJsonObject.Create;
  obj.AddPair('Id', IntToStr(Self.Id));
  obj.AddPair('Nr', Self.Nr);
  obj.AddPair('Bezeichnung', Self.Bezeichnung);
  obj.AddPair('Abrechnung', BooleanToStr(Self.Abrechnung));
  Result := obj.ToString;
end;

function TFakModel.ToString: string;
begin
  Result := Self.Nr + #9 + Self.Bezeichnung;
end;

function TFakModel.ToStringV1: string;
begin
  Result := '';
  if Self.Nr <> '' then
    Result := Result + ' ' + Self.Nr;
  if Self.Bezeichnung <> '' then
    Result := Result + ' ' + Self.Bezeichnung;
  Result:=Trim(Result);
end;

procedure TFakModel.SetValues(json: string);
var
  obj: TJsObject;
begin
  obj := TJsJson.parseObject(json);
  Self.SetValues(obj);
end;

end.
